import { IPromiseParam } from '../base';
import * as types from './actionTypes.user';

export const signIn = ({ email, password, hex, resolve, reject }) => ({
    type: types.SIGN_IN_USER_REQ,
    email, password, hex, resolve, reject
});

export const signUp = ({ email, password, invitationCode }) => ({
    type: types.SIGN_UP_USER_REQ,
    email, password, invitationCode
});

export const authorise = () => ({
    type: types.USER_AUTHORIZE_REQ
});

export const logOut = () => ({
    type: types.USER_LOG_OUT
});

export const verifySignUp = ({ hex, resolve, reject }) => ({
    type: types.VERIFY_USER_SIGN_UP_REQ,
    hex,
    resolve,
    reject
});

export const resetVerificationEmailInfoData = () => ({
    type: types.RESET_LAST_VERIFICATION_EMAIL_INFO_REQ,
});


export const getProfile = ({ resolve, reject }) => ({
    type: types.GET_PROFILE_REQ,
    resolve, reject
});

export const getGithubLoginName = ({ resolve, reject }) => ({
    type: types.GET_GITHUB_LOGIN_NAME_REQ,
    resolve, reject
});

export const redirectAfterGithubOauthError = () => ({
    type: types.REDIRECT_AFTER_GITHUB_OAUTH_ERR_REQ,
});

export const updateProfile = (firstName, lastName, companyName) => ({
    type: types.UPDATE_PROFILE_REQ,
    firstName,
    lastName,
    companyName
});

export const changePassword = (email, password, oldPassword, resolve, reject) => ({
    type: types.CHANGE_PASSWORD_REQ,
    email,
    password,
    oldPassword,
    resolve, reject
});

export const requestRestorePasswordEmail = ({ email }) => ({
    type: types.REQUEST_PASSWORD_RESTORE_EMAIL_REQ,
    email
});

export const restorePassword = ({ email, password, hex }) => ({
    type: types.RESTORE_PASSWORD_REQ,
    email,
    password,
    hex
});

export const checkIfRestorePasswordAvailable = ({ hex, email, resolve, reject }) => ({
    type: types.CHECK_IF_RESTORING_PASSWORD_AVAILABLE_REQ,
    hex,
    email,
    resolve,
    reject
});

export const getGoogleOauthUrl = ({ invitationCode, resolve, reject }) => ({
    type: types.GET_GOOGLE_OAUTH_URL_REQ,
    invitationCode,
    resolve,
    reject
});

export const googleSignUp = ({ code, resolve, reject }) => ({
    type: types.GOOGLE_SIGN_UP_REQ,
    code,
    resolve,
    reject
});

export const googleSignIn = ({ code, invitationCode, resolve, reject }) => ({
    type: types.GOOGLE_SIGN_IN_REQ,
    code,
    invitationCode,
    resolve,
    reject
});

export const getGithubOauthUrl = ({ action, repositoryAccess, invitationCode, withUserId, resolve, reject }) => ({
    type: types.GET_GITHUB_OAUTH_URL_REQ,
    action,
    repositoryAccess,
    invitationCode,
    withUserId,
    resolve,
    reject
});

export const githubSignUp = ({ code, resolve, reject }) => ({
    type: types.GITHUB_SIGN_UP_REQ,
    code,
    resolve,
    reject
});

export const githubSignIn = ({ code,invitationCode, resolve, reject }) => ({
    type: types.GITHUB_SIGN_IN_REQ,
    code,
    invitationCode,
    resolve,
    reject
});

export const assignGithubAccount = ({ code, repositoryAccess, resolve, reject }) => ({
    type: types.ASSIGN_GITHUB_ACCOUNT_REQ,
    code,
    repositoryAccess,
    resolve,
    reject
});

export const getPaymentHistory = ({ resolve, reject }) => ({
    type: types.GET_PAYMENT_HISTORY_REQ,
    resolve,
    reject
});

export const getGithubPromoInfo = ({ resolve, reject }: IPromiseParam = {}) => ({
    type: types.GET_GITHUB_PROMO_INFO_REQ,
    resolve,
    reject
});

export const getUserBalance = () => ({
    type: types.GET_USER_BALANCE_REQ,
});

export const getPlans = ({ resolve, reject }) => ({
    type: types.GET_PLANS_REQ,
    resolve,
    reject
});

export const showChangePlanPopup = ({ nextPlan }) => ({
    type: types.SHOW_CHANGE_PLAN_POPUP,
    nextPlan
});

export const changePlan = ({ planId, onlyCheck, paymentId, paymentType, resolve, reject }) => ({
    type: types.CHANGE_PLAN_REQ,
    planId,
    paymentId,
    paymentType,
    onlyCheck,
    resolve,
    reject
});

export const verifyPlan = ({ code, resolve, reject }) => ({
    type: types.VERIFY_PLAN_REQ,
    code,
    resolve,
    reject
});

export const resetNextPlanTransition = ({ resolve, reject }) => ({
    type: types.RESET_NEXT_PLAN_TRANSITION_REQ,
    resolve,
    reject
});

export const getUserPaymentMethods = () => ({
    type: types.GET_USER_PAYMENT_METHODS_REQ,
});

export const cancelEnterpriseSubscription = ({ planId, resolve, reject }) => ({
    type: types.CANCEL_ENTERPRISE_SUBSCRIPTION_REQ,
    planId,
    resolve,
    reject
});

export const resumeEnterpriseSubscription = ({ resolve, reject }) => ({
    type: types.RESUME_ENTERPRISE_SUBSCRIPTION_REQ,
    resolve,
    reject
});

export const inviteFriend = ({ email, resolve, reject }) => ({
    type: types.INVITE_FRIENDS_REQ,
    email,
    resolve,
    reject
});

export const getInvitedFriendsInfo = ({ resolve, reject }) => ({
    type: types.GET_INVITED_FRIENDS_INFO_REQ,
    resolve,
    reject
});

export const getResourceUsage = ({ resolve, reject }) => ({
    type: types.GET_RESOURCE_USAGE_REQ,
    resolve,
    reject
});


